import { createRouter, createWebHistory } from "vue-router";

const Dashboard = () => import("../vue/Dashboard.vue");
const Building = () => import("../vue/buildings/Show.vue");
const District = () => import('../vue/districts/Show.vue');
const Scenario = () => import("../vue/scenarios/ScenarioShow.vue");
const DistrictBuilding = () => import("../vue/districts/DistrictBuilding.vue")
const LcaResults = () => import('../vue/buildings/LcaResults.vue')
const DistrictLcaResults = () => import('../vue/districts/LcaResults.vue')
const TimeSeriesCharts = () => import('../vue/buildings/TimeSeriesCharts.vue');
const TimeSeriesTable = () => import('../vue/buildings/TimeSeriesTable.vue');
const ClientsIndex = () => import('../vue/admin/clients/Index.vue');
const AccessRules = () => import('../vue/admin/access_rules/AccessRules.vue');
const MiniTutorial = () => import('../vue/MiniTutorial.vue');

import { ModelTableStore } from '../vue/shared/stores/modelTableStore'

const routes = [
    { path: '/dashboard', component: Dashboard, name: 'dashboard_path' },
    { path: '/admin/clients', component: ClientsIndex, name: 'admin_clients_path' },
    { path: '/admin/access_rules', component: AccessRules, name: 'admin_access_rules_path' },
    /* Building */
    /* Also includes routes scoped for client. */

    /* Show */
    { path: '/buildings/:id', component: Building, name: 'building_path' },
    { path: '/client/:clientName/buildings/:id', component: Building, name: 'client_building_path' },
    /* Scenario */
    { path: '/buildings/:id/scenarios/:scenario_id', component: Scenario, name: 'building_scenario_path' },
    { path: '/client/:clientName/buildings/:id/scenarios/:scenario_id', component: Scenario, name: 'client_building_scenario_path' },
    /* Other */
    { path: '/buildings/:id/lca_analysis', component: LcaResults, name: 'building_lca_results_path' },
    { path: '/buildings/:id/scenarios/:scenario_id/time_series_charts', component: TimeSeriesCharts, name: 'building_time_series_charts_path'},
    { path: '/buildings/:id/scenarios/:scenario_id/time_series_table', component: TimeSeriesTable, name: 'building_time_series_table_path'},

    /* District */
    /* Also includes routes scoped for client. */
    { path: '/districts/:id', component: District, name: 'district_path' },
    { path: '/client/:clientName/districts/:id', component: District, name: 'client_district_path' },
    { path: '/districts/:id/scenarios/:scenario_id', component: Scenario, name: 'district_scenario_path' },
    { path: '/districts/:id/scenarios/:scenario_id/time_series_table', component: TimeSeriesTable, name: 'district_time_series_table_path' },
    { path: '/districts/:id/scenarios/:scenario_id/buildings/:building_id/time_series_table', component: TimeSeriesTable, name: 'district_building_time_series_table_path'},
    { path: '/districts/:id/scenarios/:scenario_id/buildings/:building_id', component: DistrictBuilding, name: 'district_scenario_building_path' },
    { path: '/districts/:id/lca_analysis', component: DistrictLcaResults, name: 'district_lca_results_path' },
    { path: '/districts/:id/scenarios/:scenario_id/buildings/:building_id/lca_district_building', component: LcaResults, name: 'district_building_lca_results_path' },

    /* Other */
    { path: '/tutorial', component: MiniTutorial, name: 'tutorial_path' },
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

let dashboardReplaced = false

router.beforeEach((to, from) => {
    if (to.name === 'dashboard_path') {
        if (to.query.hasOwnProperty('source') && to.query.source === 'navbar') {
            dashboardReplaced = true
            return { path: to.path, replace: true }
        } else {
            if (!dashboardReplaced) {
                const store = ModelTableStore()
                store.$reset()
            }

            /* Cleans the URL for the `client` query. Used for page reloads from browser
               while viewing a managed client. */
            if (to.query.hasOwnProperty('client') && from.name === undefined) {
                const cleanQuery = { ...to.query }
                delete cleanQuery['client']

                return { path: to.path, replace: true, query: cleanQuery }
            }
        }
    }
})

export default router;